/**
 * Valida formato de email: usuario@dominio.ext (requiere @ y al menos un punto en el dominio).
 */
export function isValidEmail(value) {
  if (value == null || typeof value !== 'string') return false;
  const s = value.trim();
  if (!s) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);
}
